import styled from 'styled-components';

import type { Size as ThemeSize } from '../../../style/types/theme';
import { Size } from '../types';

export interface WrapperProps {
  $color: string;
  $size: Size;
}

const getSize = (size: Size, themeSize: ThemeSize) => {
  switch (size) {
    case Size.XS:
      return themeSize.units(2);
    case Size.S:
      return themeSize.units(3);
    case Size.M:
      return themeSize.units(4);
    case Size.L:
      return themeSize.units(5);
    case Size.XL:
      return themeSize.units(8);
    case Size.XXL:
      return themeSize.units(10);
    case Size.XXXL:
      return themeSize.units(16);
    default:
      return themeSize.units(4);
  }
};

export const Wrapper = styled.div<WrapperProps>(({ $color, $size, theme: { size } }) => ({
  height: getSize($size, size),
  width: getSize($size, size),
  backgroundColor: $color,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Text = styled.span(({ theme: { color, font, size } }) => ({
  fontFamily: font.family,
  fontWeight: 700,
  fontStyle: 'normal',
  fontSize: size.units(1.875),
  lineHeight: size.units(2.5),
  color: color.content.reversed.default(),
  textTransform: 'capitalize',
}));
